"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRepurchaseConfirmationJobReceivablesPayloadConfig = exports.isReceivableResponseTapePreviewPayloadConfig = exports.isRepurchaseConfirmationJobConfig = exports.isPreassignedInternalLoanTapesFromSignaledAssignmentsPayloadConfig = exports.isDefaultPreviewEmailPayloadConfig = exports.isSingleReceivableResponseTapePreviewPayloadConfig = exports.isReceivableResponseTapePreviewsFromStrategyPayloadConfig = exports.hasSanitizedNormalizedRepaymentInputFields = exports.isInternalAssignedRepaymentTape = exports.isInternalRepaymentTape = exports.isLoanTapeType = void 0;
const lodash_1 = __importDefault(require("lodash"));
const schema = __importStar(require("../schema"));
const typeguardUtils_1 = require("./typeguardUtils");
const loanTapeTypes = {
    masterLoanTape: 'masterLoanTape',
    preassignedLoanTape: 'preassignedLoanTape',
    preassignedMasterLoanTape: 'preassignedMasterLoanTape',
};
const isLoanTapeType = (str) => lodash_1.default.values(loanTapeTypes).indexOf(str) !== -1;
exports.isLoanTapeType = isLoanTapeType;
exports.isInternalRepaymentTape = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.InternalRepaymentTapeSchema,
    typeguardName: 'isInternalRepaymentTape',
});
exports.isInternalAssignedRepaymentTape = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.InternalAssignedRepaymentTapeSchema,
    typeguardName: 'isInternalAssignedRepaymentTape',
});
exports.hasSanitizedNormalizedRepaymentInputFields = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.SanitizedNormalizedRepaymentInputFieldsSchema,
    typeguardName: 'hasSanitizedNormalizedRepaymentInputFields',
});
exports.isReceivableResponseTapePreviewsFromStrategyPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReceivableResponseTapePreviewsFromStrategyPayloadSchema,
    typeguardName: 'isReceivableResponseTapePreviewsFromStrategyPayloadConfig',
});
exports.isSingleReceivableResponseTapePreviewPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.SingleReceivableResponseTapePreviewPayloadSchema,
    typeguardName: 'isSingleReceivableResponseTapePreviewPayloadConfig',
});
exports.isDefaultPreviewEmailPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.DefaultPreviewEmailPayloadSchema,
    typeguardName: 'isDefaultPreviewEmailPayloadConfig',
});
exports.isPreassignedInternalLoanTapesFromSignaledAssignmentsPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.PreassignedInternalLoanTapesFromSignaledAssignmentsPayloadSchema,
    typeguardName: 'isPreassignedInternalLoanTapesFromSignaledAssignmentsPayloadConfig',
});
exports.isRepurchaseConfirmationJobConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.RepurchaseConfirmationJobPayloadSchema,
    typeguardName: 'isRepurchaseConfirmationJobConfig',
});
exports.isReceivableResponseTapePreviewPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.ReceivableResponseTapePreviewPayloadSchema,
    typeguardName: 'isReceivableResponseTapePreviewPayloadConfig',
});
exports.isRepurchaseConfirmationJobReceivablesPayloadConfig = (0, typeguardUtils_1.typeguardFunctionLogWrapper)({
    schema: schema.RepurchaseConfirmationJobReceivablesPayloadSchema,
    typeguardName: 'isRepurchaseConfirmationJobReceivablesPayloadConfig',
});
//# sourceMappingURL=loanProduct.js.map